<template lang="pug">
	modal
		.card.text-left
			.card-header
				button.close(@click="cerrar") &times;
			.card-body
				CalendarioAnual(:seleccion.sync="linea.dias", :from="contrato.FechaInicio", :to="contrato.FechaFin")
</template>


<script>
import CalendarioAnual from '../../../../../gestion-emisoras/vue/componentes/utilidades/calendario-anual.vue'
export default {
	props: ['linea', 'contrato'],
	components: {
		CalendarioAnual
	},
	created () {
		console.log(this.linea)
	},
	methods: {
		cerrar () {
			// Emitimos cierre
			this.$emit('cerrar')
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/modulos/radiacion/vue/components/radiacion/insertar-originales/modal-calendario.vue